import React from "react";

const CheckBox = ({ checked, onChange }) => {
    return (
      <i
        className="material-icons font-16 hyperlink"
        onClick={() => onChange(!checked)}
      >
        {checked ? "check_box" : "check_box_outline_blank"}
      </i>
    );
  };

export default CheckBox;